var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadLedgerIconCp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 11L2.75 6.41667L4.03333 5.0875L6.41667 7.47083V0H8.25V7.47083L10.6333 5.0875L11.9167 6.41667L7.33333 11ZM1.83333 14.6667C1.32917 14.6667 0.89757 14.4872 0.538542 14.1281C0.179514 13.7691 0 13.3375 0 12.8333V10.0833H1.83333V12.8333H12.8333V10.0833H14.6667V12.8333C14.6667 13.3375 14.4872 13.7691 14.1281 14.1281C13.7691 14.4872 13.3375 14.6667 12.8333 14.6667H1.83333Z",
    fill: "#E86A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLedgerIconCp);
export default __webpack_public_path__ + "static/media/download-ledgerIcon-cp.663115801ca09299c8365ee26803e16f.svg";
export { ForwardRef as ReactComponent };